export function rfiSubmissionLink(rfiId, submissionId, packageVersionId) {
    return `/rfi-response/${encodeURIComponent(rfiId)}?submission=${encodeURIComponent(submissionId)}&packageVersion=${encodeURIComponent(packageVersionId)}#rfi-submission-${encodeURIComponent(submissionId)}`;
}
export function rfiFeedbackLink(rfiId, versionId) {
    return `/rfi-response/${encodeURIComponent(rfiId)}?feedbackVersion=${encodeURIComponent(versionId)}#rfi-feedback-${encodeURIComponent(versionId)}`;
}
export function rfiAdoptionLink(a) {
    const params = new URLSearchParams(a.targetKind === 'customer_theme' ? {
        tab: 'themes',
        overviewKind: 'theme',
        overviewId: a.targetId,
        themeVersion: a.resultVersionId
    } : {
        tab: 'solution',
        solutionRevision: a.resultVersionId,
        solutionTarget: a.targetId
    });
    return `/capture/${encodeURIComponent(a.captureProjectId)}?${params}`;
}
